export function isCustomerDashboardRole(role: string | undefined): boolean {
  if (!role) return false;
  return role === "customer" || role === "property_manager" || role === "property-manager";
}

export function getRedirectPath(role: string | undefined): string {
  if (!role) return "/customer/dashboard";
  switch (role) {
    case "vendor":
      return "/vendor/leads";
    case "property_manager":
    case "property-manager":
      return "/customer/dashboard";
    case "admin":
      return "/admin/dashboard";
    default:
      return "/customer/dashboard";
  }
}

export function isValidReturnUrl(url: string | null | undefined): boolean {
  if (!url || typeof url !== "string") return false;
  const trimmed = url.trim();
  if (trimmed === "" || !trimmed.startsWith("/") || trimmed.startsWith("//")) return false;
  return true;
}

export function getLoginRedirectUrl(options: {
  returnUrl?: string | null;
  role?: string;
  defaultPath?: string;
}): string {
  const { returnUrl, role, defaultPath } = options;
  if (isValidReturnUrl(returnUrl)) return returnUrl!;
  return defaultPath ?? getRedirectPath(role);
}

/** NextAuth redirect target: completes OAuth then issues app JWT + Zustand sync before `returnUrl`. */
export function getGoogleOAuthBridgeCallbackUrl(options: {
  returnUrl?: string | null;
  role?: string;
  defaultPath?: string;
}): string {
  const destination = getLoginRedirectUrl({
    returnUrl: options.returnUrl,
    role: options.role,
    defaultPath: options.defaultPath ?? "/customer/dashboard",
  });
  const params = new URLSearchParams();
  params.set("returnUrl", destination);
  return `/login/oauth-bridge?${params.toString()}`;
}

export function isCurrentPath(url: string | undefined): boolean {
  if (typeof window === "undefined" || !url) return false;
  try {
    const normalized = url.startsWith("/") ? url : new URL(url, window.location.origin).pathname;
    return decodeURIComponent(normalized) === decodeURIComponent(window.location.pathname);
  } catch {
    return false;
  }
}

const PROTECTED_PATH_PREFIXES = [
  "/customer/",
  "/vendor/",
  "/manager/",
  "/admin/",
  "/onboarding/",
] as const;

export function isPathRequiringAuth(pathname: string): boolean {
  if (!pathname || typeof pathname !== "string") return false;
  const normalized = pathname.startsWith("/") ? pathname : `/${pathname}`;
  return PROTECTED_PATH_PREFIXES.some((prefix) => normalized.startsWith(prefix));
}
